import { useCallback, useEffect, useState } from "react";
import { platosApi } from "../api/platosApi";
import { alergenosApi } from "../api/alergenosApi";

export function usePlatosData() {
    const [platos, setPlatos] = useState([]);
    const [alergenos, setAlergenos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const reload = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const [p, a] = await Promise.all([platosApi.listAll(), alergenosApi.listAll()]);
            setPlatos(Array.isArray(p) ? p : []);
            setAlergenos(Array.isArray(a) ? a : []);
        } catch (e) {
            setError(e?.message || "Error cargando datos");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        reload();
    }, [reload]);

    return { platos, alergenos, loading, error, reload, setPlatos };
}
